// src/redux/catalogs/states/citiesSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGuestSpeaker } from "../../../interfaces/models/IGuestSpeaker";

const initialState: IGuestSpeaker[] = [];

export const guestSpeakersSlice = createSlice({
  name: "guestSpeaker",
  initialState,
  reducers: {
    SetGuestSpeakers: (_, action: PayloadAction<IGuestSpeaker[]>) => action.payload,
    AddGuestSpeaker: (state, action: PayloadAction<IGuestSpeaker>) => {
      state.push(action.payload);
    },
    UpdateGuestSpeaker: (state, action: PayloadAction<IGuestSpeaker>) => {
      const index = state.findIndex((guestSpeaker) => guestSpeaker.id === action.payload.id);
      if (index !== -1) {
        state[index] = { ...state[index], ...action.payload };
      }
    },
    DeleteGuestSpeaker: (state, action: PayloadAction<string>) => {
      return state?.filter((guestSpeaker) => guestSpeaker.id !== action.payload);
    },
  },
});

export const { SetGuestSpeakers, AddGuestSpeaker, UpdateGuestSpeaker, DeleteGuestSpeaker } =
  guestSpeakersSlice.actions;
export default guestSpeakersSlice.reducer;
